import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SignupGuard} from './auth/signup/signup.guard';
import {LoginGuard} from './auth/login/login.guard';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('@content/pages/pages.module').then(m => m.PagesModule),
    },
    {
        path: 'login',
        canActivate: [LoginGuard],
        loadChildren: () => import('./auth/login/login.module').then(m => m.LoginModule),
    },
    {
        path: 'reset-password',
        loadChildren: () => import('./auth/reset-password/reset-password.module').then(m => m.ResetPasswordModule),
    },
    {
        path: 'signup',
        canActivate: [SignupGuard],
        loadChildren: () => import('./auth/signup/signup.module').then(m => m.SignupModule),
    },
    {
        path: 'sso',
        loadChildren: () => import('./auth/sso/sso.module').then(m => m.SsoModule),
    },
    {
        path: 'live-lineage',
        loadChildren: () => import('./live-lineage/live-lineage.module').then(m => m.LiveLineageModule),
    },
    {
        path: '**',
        redirectTo: 'lineage',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {useHash: true, onSameUrlNavigation: 'reload'})
    ],
    exports: [
        RouterModule,
    ]
})
export class AppRoutingModule {
}
